var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("LayoutLanding", {
    staticClass: "automation-landing",
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function() {
          return [
            _c("div", { staticClass: "automation-landing__content" }, [
              _c("div", { staticClass: "automation-landing__title-section" }, [
                _c(
                  "h1",
                  {
                    staticClass:
                      "automation-landing__title typographies-display-brand-medium"
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.translations.title) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass:
                      "automation-landing__subtitle typographies-paragraph-medium-regular"
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.translations.subtitle) +
                        "\n                "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "automation-landing__actions" },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "automation-landing__actions-title typographies-paragraph-caps-medium-bold"
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.translations.titleActions) +
                          "\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.cards, function(card) {
                    return _c("AutomationLandingCard", {
                      key: card.id,
                      attrs: {
                        icon: card.icon,
                        title: card.title,
                        caption: card.caption,
                        disabled: card.disabled,
                        soon: card.soon,
                        tooltipProps: card.tooltipProps,
                        dataBot: card.dataBot
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleCardClick(card.id)
                        }
                      }
                    })
                  })
                ],
                2
              )
            ])
          ]
        },
        proxy: true
      },
      {
        key: "illustration",
        fn: function() {
          return [
            _c("picture", [
              _c("source", {
                attrs: {
                  srcset: _vm.illustrationSmallSrc,
                  media: "(max-width: 1279px)"
                }
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "automation-landing__illustration",
                attrs: {
                  src: _vm.illustrationDefaultSrc,
                  alt: "Automation Illustration"
                }
              })
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }